import React from "react"
import LandingHome from "../section/LandingHome";
import SlidertTopText from "../section/SlidertTopText";
import AboutSection from "../section/AboutSection";
import OutWorkSection from "../section/OutWorkSection";
import ServicesSection from "../section/ServicesSection";
import BookingSection from "../section/BookingSection";
import AqabaSection from "../section/AqabaSection";
import EventSection from "../section/EventSection";

export default function Home(){
    return(
        <>
            <LandingHome/>
            <SlidertTopText/>
            <AboutSection/>
            <AqabaSection/>
            <OutWorkSection/>
            <EventSection/>
            <ServicesSection/>
            <BookingSection/>
        </>
    );
}